import axios from "axios";

const instrumentoApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/instrumento`
})

async function servGetAllInstrumentos() {
    const response = await instrumentoApi.get('')
    return response
}

export {
    servGetAllInstrumentos
}